import * as IconSelector from '../icons';

// Constantes exportadas
export const AUTH_ACTION_DECLARACIONES = 'Declaraciones';
export const AUTH_ACTION_SOLICITUDES = 'Solicitudes';
export const AUTH_ACTION_CONSULTAS = 'Consultas';
export const AUTH_ACTION_AUTORIZACIONES = 'Autorizaciones';
export const AUTH_ACTION_TODO = 'Todo';

// Definición del enum
export const authAction = [
    {
        value: AUTH_ACTION_DECLARACIONES,
        label: 'Declaraciones',
        description: 'Puede hacer Declaraciones',
        icon: IconSelector.PointIcon,
        color: 'Blue'
    },
    {
        value: AUTH_ACTION_SOLICITUDES,
        label: 'Solicitudes',
        description: 'Puede hacer solicitudes',
        icon: IconSelector.PointIcon,
        color: 'Green'
    },
    {
        value: AUTH_ACTION_CONSULTAS,
        label: 'Consultas',
        description: 'Puede realizar consultas',
        icon: IconSelector.PointIcon,
        color: 'DarkOrange'
    },
    {
        value: AUTH_ACTION_AUTORIZACIONES,
        label: 'Autorizaciones',
        description: 'Puede autorizar a otros',
        icon: IconSelector.PointIcon,
        color: 'Red'
    },
    {
        value: AUTH_ACTION_TODO,
        label: 'Todo',
        description: 'Puede realizar cualquier tramite',
        icon: IconSelector.PointIcon,
        color: 'Black'
    }
];
